import React from 'react';

function PoliticaCookies() {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '80vh',
            fontSize: '3rem',
            fontWeight: 'bold'
        }}>
            În curând
        </div>
    );
}

export default PoliticaCookies;
